import { render, staticRenderFns } from "./MatrixGraduatedPrices.vue?vue&type=template&id=73e3b790&"
import script from "./MatrixGraduatedPrices.vue?vue&type=script&lang=js&"
export * from "./MatrixGraduatedPrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Misha\\Documents\\GitHub\\matrix_varianten\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73e3b790')) {
      api.createRecord('73e3b790', component.options)
    } else {
      api.reload('73e3b790', component.options)
    }
    module.hot.accept("./MatrixGraduatedPrices.vue?vue&type=template&id=73e3b790&", function () {
      api.rerender('73e3b790', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/MatrixGraduatedPrices.vue"
export default component.exports